var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(-5829 -3286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M5835.814,3296.5v2.516a.772.772,0,0,1-.641.76v3.992h-2.981v-3.992a.772.772,0,0,1-.64-.76V3296.5a.772.772,0,0,1,.77-.771h2.721A.773.773,0,0,1,5835.814,3296.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M5833.681,3294.177a1.379,1.379,0,1,0-1.379-1.379A1.382,1.382,0,0,0,5833.681,3294.177Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M5843.159,3295.164v3.776a1.159,1.159,0,0,1-.962,1.14v5.989h-4.472v-5.989a1.159,1.159,0,0,1-.961-1.14v-3.776a1.158,1.158,0,0,1,1.156-1.156H5842A1.158,1.158,0,0,1,5843.159,3295.164Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M5839.96,3292.17a2.12,2.12,0,1,0-2.119-2.12A2.124,2.124,0,0,0,5839.96,3292.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M5848.448,3296.5v2.516a.772.772,0,0,1-.64.76v3.992h-2.981v-3.992a.772.772,0,0,1-.641-.76V3296.5a.773.773,0,0,1,.771-.771h2.721A.772.772,0,0,1,5848.448,3296.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M5846.2,3294.177a1.379,1.379,0,1,0-1.379-1.379A1.382,1.382,0,0,0,5846.2,3294.177Z"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 22,
    height: 22,
    transform: "translate(5829 3286)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeams);
export default __webpack_public_path__ + "static/media/icon-teams.1fadb5e97b9e1fed7b5365cc8e350b06.svg";
export { ForwardRef as ReactComponent };